export const globalTourSteps = {
  connectMyCluster: 'connect-my-cluster',
  enableSecurity: 'enable-security',
};
